
import { Component, Mixins} from "vue-property-decorator"
import Common from '../../mixins/common';
import StaffInbox from "@/components/StaffInbox.vue"
import UserInbox from "@/components/UserInbox.vue"
import NotificationEvents from "@/components/NotificationEvents.vue"

@Component({
  components: {
    StaffInbox,
    UserInbox,
    NotificationEvents,
  }
})

export default class Dashboard extends Mixins(Common) {
  isNoticeLineAccountShow = true
  
  get isStaff(){
    return !! this.$store.getters.isStaff
  }

  get linkedlineAccount(){
    return !! this.$store.state.userPrivateProfile.lineUserId
  }

  get userId(){
    return this.$store.getters.userId as string
  }

  
  get schoolId(): string{
    return this.$store.getters.schoolId
  }

  async created(){
    try{
//
}catch(error){
      console.log(error)
    }
  }

  

  destroyed() {
  //
  }
}
